import {
  Shirt, Venus, Baby, Footprints, ShoppingBag, Gem, Sparkles,
  HeartPulse, UtensilsCrossed, Sofa, Palette, Smartphone, BookOpen, Package,
} from "lucide-react";

// Brand accent palette — cycled across the category tiles for visual rhythm.
const ACCENTS = [
  { accent: "from-[#C05A3C]/15 to-[#C05A3C]/0", ring: "ring-[#C05A3C]/30" },
  { accent: "from-[#D9923B]/18 to-[#D9923B]/0", ring: "ring-[#D9923B]/30" },
  { accent: "from-[#2A3D36]/15 to-[#2A3D36]/0", ring: "ring-[#2A3D36]/30" },
  { accent: "from-[#1A2024]/12 to-[#1A2024]/0", ring: "ring-[#1A2024]/30" },
];

const RAW = [
  { label: "Men's Clothing", icon: Shirt },
  { label: "Women's Clothing", icon: Venus },
  { label: "Kids & Baby", icon: Baby },
  { label: "Shoes & Footwear", icon: Footprints },
  { label: "Bags & Accessories", icon: ShoppingBag },
  { label: "Jewelry", icon: Gem },
  { label: "Beauty & Hair", icon: Sparkles },
  { label: "Health & Wellness", icon: HeartPulse },
  { label: "Food & Spices", icon: UtensilsCrossed },
  { label: "Home & Decor", icon: Sofa },
  { label: "Art & Crafts", icon: Palette },
  { label: "Electronics", icon: Smartphone },
  { label: "Books & Media", icon: BookOpen },
  { label: "Other", icon: Package },
];

export const PRODUCT_CATEGORIES = RAW.map((c, i) => ({ ...c, ...ACCENTS[i % ACCENTS.length] }));

export const categorySlug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

export const categoryHref = (label) => `/browse?type=product&category=${encodeURIComponent(label)}`;
